import React, { Fragment } from 'react';
import { CreditCardOutlined, DollarOutlined, PayCircleOutlined, MobileOutlined } from '@ant-design/icons';
import { Divider, Menu } from 'antd';
import { Link, Route, Navigate, useLocation, Routes, useNavigate } from 'react-router-dom';
import InnerAppLayout from 'layouts/inner-app-layout';
import { useMyContext } from 'Context/MyContextProvider';
import RazorpayGateway from './components/RazorpayGateway';
import InstaMojoGateway from './components/InstaMojoGateway';
import EasebuzzGateway from './components/EasebuzzGateway';
import PhonePeGateway from './components/PhonePeGateway';

const url = '/payment-gateway'

const PaymentGateway = () => {
    const { api, authToken, UserData, themeData } = useMyContext();
    const navigate = useNavigate();
    return (
        <InnerAppLayout
            sideContentWidth={320}
            sideContent={<GatewayOptions api={api} authToken={authToken} navigate={navigate} UserData={UserData} />}
            mainContent={<GatewayContent themeData={themeData} api={api} authToken={authToken} navigate={navigate} UserData={UserData} />}
        />
    );
}

const MenuItem = ({ icon, path, label }) => {
    return (
        <div>
            {icon}
            <span>{label}</span>
            <Link to={`${url}/${path}`} />
        </div>
    );
};

const GatewayOptions = ({ api, authToken, navigate }) => {
    const location = useLocation();
    const locationPath = location.pathname.split('/');
    const currentpath = locationPath[locationPath.length - 1];
    const { Permisson } = useMyContext();
    const gateways = [
        { key: 'razorpay', label: 'Razorpay', icon: <CreditCardOutlined /> },
        { key: 'instamojo', label: 'InstaMojo', icon: <DollarOutlined /> },
        { key: 'easebuzz', label: 'Easebuzz', icon: <PayCircleOutlined /> },
        { key: 'phonepe', label: 'PhonePe', icon: <MobileOutlined /> },
    ];
    return (
        <Menu mode="inline" selectedKeys={[currentpath]} className="h-100">
            {gateways.map(({ key, label, icon }) => (
                <Fragment key={key}>
                    <Menu.Item key={key} icon={icon} style={{ margin: 0 }}>
                        <MenuItem label={label} path={key} />
                    </Menu.Item>
                    <Divider className='m-0 p-0'/>
                </Fragment>
            ))}
        </Menu>
    );
};

const GatewayContent = ({ api, authToken, navigate, UserData, themeData }) => {
    return (
        <Routes>
            {/* <Route path={`/`} exact element={<RazorpayGateway UserData={UserData} api={api} authToken={authToken} navigate={navigate} />} /> */}
            <Route path={`/razorpay`} exact element={<RazorpayGateway UserData={UserData} api={api} authToken={authToken} navigate={navigate} />} />
            <Route path={`/instamojo`} exact element={<InstaMojoGateway UserData={UserData} api={api} authToken={authToken} navigate={navigate} />} />
            <Route path={`/easebuzz`} exact element={<EasebuzzGateway UserData={UserData} api={api} authToken={authToken} navigate={navigate} />} />
            <Route path={`/phonepe`} exact element={<PhonePeGateway UserData={UserData} api={api} authToken={authToken} navigate={navigate} />} />
            {/* <Route path={`/*`} exact element={<Navigate to={`razorpay`} />} /> */}
        </Routes>
    );
};

export default PaymentGateway;